module.exports = __webpack_public_path__ + "static/media/recovery-book9.4592416c.png";